var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwiterGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0807 18.3403C38.4275 18.6218 37.718 18.8245 36.986 18.9034C37.7405 18.4529 38.3149 17.7434 38.5852 16.8987C37.8869 17.3154 37.0986 17.6195 36.2765 17.7772C35.612 17.0676 34.666 16.6284 33.6186 16.6284C31.6027 16.6284 29.9809 18.2614 29.9809 20.2661C29.9809 20.5477 30.0147 20.8292 30.071 21.0995C27.0527 20.9418 24.3611 19.5003 22.5704 17.2929C22.255 17.8335 22.0748 18.4529 22.0748 19.1286C22.0748 20.39 22.7168 21.5049 23.6966 22.1581C23.0997 22.1356 22.5366 21.9667 22.0523 21.6964C22.0523 21.7077 22.0523 21.7302 22.0523 21.7414C22.0523 23.5096 23.3024 24.9737 24.9692 25.3116C24.6651 25.3904 24.3385 25.4354 24.0119 25.4354C23.7754 25.4354 23.5502 25.4129 23.3249 25.3791C23.7867 26.8207 25.1269 27.8681 26.7261 27.9019C25.476 28.8817 23.9106 29.456 22.21 29.456C21.9059 29.456 21.6244 29.4448 21.3315 29.411C22.942 30.4471 24.8566 31.044 26.9176 31.044C33.6073 31.044 37.2675 25.503 37.2675 20.6941C37.2675 20.5364 37.2675 20.3787 37.2563 20.2211C37.9658 19.703 38.5852 19.061 39.0807 18.3403Z",
    fill: "#0DD0BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4963",
    x: -8.57786,
    y: -11.5862,
    width: 77.8276,
    height: 77.8276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.82759
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.2069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.52549 0 0 0 0 0.898039 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4963"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4963",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiterGreen);
export default __webpack_public_path__ + "static/media/twiter-green.237687d46a2e67bec8f7da2dd5b3924c.svg";
export { ForwardRef as ReactComponent };